import React from "react";
import { SponsorContainer } from "../../../containers";

const Sponsor = (props) => {
  return <SponsorContainer {...props} />;
};

export default Sponsor;
